import "ol/ol.css";
import Map from "ol/Map";
import { Draw } from "ol/interaction";
import MapBrowserEvent from "ol/MapBrowserEvent";
import { LineString } from "ol/geom";
import { DrawEvent } from "ol/interaction/Draw";
import Feature from "ol/Feature";
import VectorSource from "ol/source/Vector";
import { getLength } from "ol/sphere";
/**
 * マウスダウンイベント定義値
 */
const EVNET_MOUSE_TYPE_DOWN = "pointerdown";

/**
 * マウス左クリックボタン定義値
 */
const EVENT_MOUSE_LEFT_BUTTON = 0;

/**
 * 描画開始イベント定義値
 */
const EVENT_DRAWSART = "drawstart";

/**
 * 距離計測処理
 */
export class DistanceCalcInteraction {
  /**
   * 地図クラス
   */
  private _map: Map;

  /**
   * 図形描画用Intraction
   */
  private _drawInteraction: Draw;

  /**
   * 描画中図形
   */
  private _drawingFeature: Feature;

  /**
   * 計測データソース
   */
  private _calSource: VectorSource;

  /**
   * 計測点追加コールバック関数
   */
  private _calcPointAddFunc: (distance: number) => any;

  /**
   * コンストラクタ
   * @param map 地図クラス
   * @param targetSource 計測データソース
   */
  public constructor(map: Map, targetSource: VectorSource) {
    this._map = map;
    this._calSource = targetSource;
  }

  /**
   * 距離計測モードを開始する。
   * @param calcPointAddFunc 計測点追加コールバック関数
   */
  public startCalc(calcPointAddFunc: (distance: number) => any) {
    this._calcPointAddFunc = calcPointAddFunc;
    this._drawInteraction = new Draw({
      source: this._calSource,
      type: "LineString",
      condition: this.drawCondition.bind(this),
    });
    this._map.addInteraction(this._drawInteraction);
    this._drawInteraction.on(EVENT_DRAWSART, this.drawStartEvent.bind(this));
  }

  /**
   * 距離計測点を削除する。
   */
  public clearCalcPoint() {
    this._drawInteraction.abortDrawing();
    this._calSource.clear();
  }

  /**
   * 距離計測モードを終了する。
   */
  public endCalc() {
    this._map.removeInteraction(this._drawInteraction);
    this._drawInteraction.un(EVENT_DRAWSART, this.drawStartEvent.bind(this));
    this._calSource.clear();
  }

  /**
   * 図形描画開始イベント
   * 計測データースの図形を削除し、描きはじめの図形を変数に設定する。
   * @param evt 描画イベント情報
   */
  private drawStartEvent(evt: DrawEvent) {
    this._calSource.clear();
    this._calcPointAddFunc(null);
    this._drawingFeature = evt.feature;
  }

  /**
   * 距離計測点追加イベント処理
   * @param evt イベント情報
   */
  private drawCondition(evt: MapBrowserEvent<any>): boolean {
    //左クリックの場合
    if (
      evt.type == EVNET_MOUSE_TYPE_DOWN &&
      evt.originalEvent.button == EVENT_MOUSE_LEFT_BUTTON
    ) {
      this._calcPointAddFunc(0);

      //図形描画開始後の場合
      if (this._drawingFeature) {
        const lineGeom = <LineString>this._drawingFeature.getGeometry();
        const coords = lineGeom.getCoordinates();

        //描画した図形の頂点が２点以上の場合
        if (coords.length >= 2) {
          const distance = getLength(lineGeom);
          this._calcPointAddFunc(distance);
        }
        return true;
      }

      //その他のマウスクリック処理の場合は、イベントを中断する。
    } else if (evt.type == EVNET_MOUSE_TYPE_DOWN) {
      return false;
    }
    return true;
  }
}
